import { FileText, Loader2, Trash2, Upload } from 'lucide-react';
import { docTypeLabel } from '../lista-report/sources';
import { STATE_CONFIG, type UiSourceState } from './sourceState';
import type { ConductRiskDocumentType } from '../../../api/apiTypesConductRisk';

interface Props {
  docType:      ConductRiskDocumentType;
  state:        UiSourceState;
  fileName?:    string | null;
  isReplacing:  boolean;
  hasLink:      boolean;
  onReplace:    (dt: ConductRiskDocumentType) => void;
  onUnlink:     (dt: ConductRiskDocumentType) => void;
}

const SourceRow = ({ docType, state, fileName, isReplacing, hasLink, onReplace, onUnlink }: Props) => {
  const cfg = STATE_CONFIG[state];
  // Sostituisci e Rimuovi sono disponibili ogni volta che c'e' un link nel BE
  // (l'utente puo' sempre ri-caricare il file per aggiornarlo o eliminarlo,
  // anche mentre il parser gira o e' in errore). L'unica condizione e' quindi
  // la presenza del link.
  const canReplace = hasLink;
  const canUnlink  = hasLink;

  return (
    <li className="flex items-center justify-between gap-3 px-3 py-2 bg-white rounded-lg border border-gray-100">
      <div className="flex items-center gap-2 min-w-0 flex-1">
        <FileText className="w-3.5 h-3.5 text-[#1B365D]/60 shrink-0" />
        <span className="text-xs font-medium text-gray-700 truncate">
          {docTypeLabel(docType)}
        </span>
        {fileName && (
          <span className="text-[10px] text-gray-400 truncate">· {fileName}</span>
        )}
      </div>

      <div className="flex items-center gap-2 shrink-0">
        <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full border text-[10px] font-semibold ${cfg.cls}`}>
          {cfg.icon}
          {cfg.label}
        </span>

        {canReplace && (
          <button
            onClick={() => onReplace(docType)}
            disabled={isReplacing}
            className="inline-flex items-center gap-1 px-2 py-1 rounded-lg text-[10px] font-medium text-[#1B365D] border border-[#1B365D]/20 hover:bg-[#1B365D]/5 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            title="Sostituisci file e riavvia il parsing"
          >
            {isReplacing
              ? <Loader2 className="w-3 h-3 animate-spin" />
              : <Upload className="w-3 h-3" />}
            Sostituisci
          </button>
        )}

        {canUnlink && (
          <button
            onClick={() => onUnlink(docType)}
            className="w-7 h-7 rounded-lg flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 transition-colors"
            title="Rimuovi fonte"
          >
            <Trash2 className="w-3.5 h-3.5" />
          </button>
        )}
      </div>
    </li>
  );
};

export default SourceRow;
